import { RegisterModule } from '@/typings/common'
import {
  PublicationsState,
  PublicationsGetters,
  PublicationsMutations,
  PublicationsActions,
} from './store'
import { createMapper, registerModule as vuexRegisterModule, Module } from 'vuex-smart-module'
import { MODULE_NAME } from '../utils'


const storeModule = (
  new Module({
    namespaced: true,
    state: PublicationsState,
    getters: PublicationsGetters,
    mutations: PublicationsMutations,
    actions: PublicationsActions,
  })
)

const mapper = createMapper(storeModule)

export {
  storeModule as marksStoreModule,
  mapper as marksMapper,
}

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
